(function () {
    require("core.less");

    require("imports?this=>global!exports?Modernizr!modernizr");
    require("expose?$!jquery");
    require("expose?jQuery!jquery");
    require('imports?this=>global,exports=>undefined!fg-loadcss');
    require('imports?this=>global!fg-loadcss/src/cssrelpreload');

    require("lazysizes/plugins/object-fit/ls.object-fit");
    require("lazysizes/plugins/bgset/ls.bgset");
    require("lazysizes/plugins/respimg/ls.respimg");
    require("lazysizes/plugins/parent-fit/ls.parent-fit");
    require("lazysizes");

	var lazyLoadInit = require("lazyload-init");
    lazyLoadInit();

    var settings = require('app.settings');
    settings.init();

    var svg = require('app.svg');
    svg.init();

    var resize = require('app.resize');
    resize.init();

    var content = require('app.content');
    content.init();

    var forms = require('app.forms');
    forms.init();

    var dropdowns = require('app.dropdowns');
    dropdowns.init();

    var carousels = require('app.carousel');
    carousels.init();

    var newlayout = require('app.newlayout');
    newlayout.init();
    var links = require('app.links');
    links.init();

    var mobilenavigation = require('app.mobilenavigation');
    mobilenavigation.init();

    var video = require('app.video');
    video.init();

    var tabs = require('app.tabs');
    tabs.init();

    var popup = require('app.popup');
    popup.init();

    var simplepopup = require('app.simplepopup');
    simplepopup.init();

    var map = require('app.map');
    map.init();

    var popupMap = require('app.popupmap');
    popupMap.init();

    var storesearch = require('app.storesearch');
    storesearch.init();

    var selectlist = require('app.selectlist');
    selectlist.init();

    var selectlistwithbutton = require('app.selectlistbtn');
    selectlistwithbutton.init();

    var socialfeed = require('app.socialfeed');
    socialfeed.init();

    var feed = require('app.feed');
    feed.init();

    var fixedonscroll = require('app.fixedonscroll');
    fixedonscroll.init();

    var social = require('app.social');
    social.init();

    var loadlist = require('app.loadlist');
    loadlist.init();

    var fasPopup = require('app.faspopup');
    fasPopup.init();

    var offerPopup = require('app.offerpopup');
    offerPopup.init();

    var basket = require('app.basket');
    basket.init();

    var tracking = require('app.gatracking');
    tracking.init();

    var stringUtils = require('app.stringutils');
    var appcookie = require('app.cookie');
    appcookie.init(fixedonscroll, stringUtils);

    var secondarynav = require('app.secondarynav');
    secondarynav.init();

    var oldbrowsers = require('app.oldbrowsers');
    oldbrowsers.init();

    var offer = require('app.offer');
    offer.init();

    var promo = require('app.promo');
    promo.init();

    var activity = require('app.activitylogger');
    activity.init();

    var quoteResult = require('app.quoteresult');
    quoteResult.init();

    var languageSelector = require('language-selector/app.language-selector');
    languageSelector.init();

    var addressConcat = require('address-concat/app.address-concat');
    addressConcat.init();

    var files = require.context("../svg/src", true, /^\.\/.*\.svg/);
    files.keys().forEach(files);

    var trustpilotPercentage = require('app.trustpilotpercentage');
    trustpilotPercentage.init();

    var timeline = require('app.timeline');
    timeline.init();

    var storeInfo = require('store-info/app.store-info');
    storeInfo.init();

    var storeimages = require('store-images/app.store-images');
    storeimages.init();

    var storefeatures = require('store-features/app.store-features');
    storefeatures.init();

    var storagesizes = require('storage-sizes-carousel/app.storage-sizes-carousel');
    storagesizes.init();

    var storageforms = require('storage-forms/app.storage-forms');
    storageforms.init();

    var pageHeaderBg = require('page-header-bg/app.page-header-bg');
    pageHeaderBg.init();

    document.addEventListener("DOMContentLoaded", function () {
        $(window).trigger('init:allIsReady');
    });
})();



/*****************
 ** WEBPACK FOOTER
 ** ./js/init.js
 ** module id = 83
 ** module chunks = 24
 **/